export function isDaylightSavingTime(date) {
  const year = date.getFullYear();

  // Datum poslední neděle v březnu (začátek letního času)
  const march = new Date(year, 2, 31);
  const marchLastSunday = new Date(march.setDate(march.getDate() - march.getDay()));

  // Datum poslední neděle v říjnu (konec letního času)
  const october = new Date(year, 9, 31);
  const octoberLastSunday = new Date(october.setDate(october.getDate() - october.getDay()));

  // Kontrola, zda aktuální datum spadá do období letního času
  return date >= marchLastSunday && date < octoberLastSunday;
}
